const messages = {
  payoutsDescription: "List of paid out BS+ items.",
  paidOut: "paid out",
  makeChoice: "Gör ditt val här.",
  seeAll: "Öppna",
  clear: "Radera",
  back: "Tillbaka",
  save: "Spara",
  close: "Nära",
  of: "Av",
  to: "till",
  copyrights: "© {date} Bridgestone Solutions. Alla rättigheter förbehållna",
  pageNotFound: "Sidan hittades inte",
  accessDenied: "åtkomst nekad",
  search: "Sök",
  year: "År",
  buttons: {
    loading: "Laddar...",
    export: "Exportera",
    delete: "Radera",
    save: "Spara",
    cancel: "Avboka",
    next: "Fortsätt",
    back: "Tillbaka",
    skip: "Hoppa över",
    send: "Skicka",
    clear: "Radera",
    readNow: "Läs nu",
    pointsList: "Poänglista",
    more: "Mer",
    close: "Nära",
    reportError: "Rapportera fel",
    accept: "Prijať",
    download: "Ladda ner",
    downloadAll: "Ladda ner alla",
    selectAll: "Välj alla",
    deselectAll: "Avmarkera alla",
    downloadSelection: "Ladda ner valda",
    dealerInfoDownload: "Ladda ner",
    toTheBasket: "Till varukorgen",
    toOrderDelivery: "Fortsätt till leveransadressen",
    discover: "Upptäck",
    newAddress: "Skapa ny leveransadress",
    selectAddressBtn: "Välj leveransadress",
    toOrderSummary: "Till orderöversikten",
    placeOrder: "Bindande beställning",
    toDashboard: "Till startsidan",
    newOrder: "Ny beställning",
    userOrders: "Till dina beställningar",
    toSearch: "Sök",
    select: "Välj",
    moreCustomerNumbers: "+ LÄGG TILL FLER KUNDNUMMER",
    loadMore: "Ladda fler",
    toStaffDashboard: "Till dashboard",
    toQuiz: "Till quiz",
    vouchers: "Kuponger",
    exchangeVoucher: "Lös in kupongkod",
    confirm: "Bekräfta",
    sharePoints: "Dela poäng",
    create: "Skapa",
    update: "Uppdatera",
    toBDrive: "Till B-Drive",
    preview: "Förhandsgranska",
    clickHere: "Visa detaljer",
    setFilters: "Ange <b>högst ett filter per kolumn</b>",
    all: "Alla",
  },
  tooltips: {
    info: "Behöver du hjälp? +46 60 140610",
  },
  confirmation: {
    header: "Bekräftelse krävs",
    message: "Do you want to delete this record?",
  },
  nav: {
    consents: "Samtycken",
    dashboard: "Hem",
    accountDashboard: "Hem",
    account: "Min profil",
    mailbox: "Inkorg",
    singleMailbox: "Meddelanden",
    stammdaten: "Masterdata",
    news_feeds: "Nyheter",
    pointsOverview: "Poängöversikt",
    rewardsOverview: "Poängöversikt",
    about: "Om BS Plus",
    service_number: "Kontakta service",
    shop: "Belöningsbutik",
    salesPromotions: "Säljkampanjer",
    promotions: "Mitt konto",
    shopCategory: "Belöningsbutik",
    productDetails: "Produktdetaljer",
    userOrders: "Användarbeställningar",
    shoppingCart: "Varukorg",
    orderDelivery: "Leveransadress",
    orderSummary: "Orderöversikt",
    orderComplete: "Beställning slutförd",
    text_page: "Statisk sida",
    staff: "Servicepanel",
    trainings: "Utbildningar",
    training: "Utbildning",
    staffVouchers: "Kuponger",
    wholesalerVouchers: "Kuponger",
    brochure_prices: "Prislistor och broschyrer",
    investment: "Investeringsstod",
    media: "Media",
    medias: "Media",
    contact_service: "Kontakt och service",
    productInfo: "PRODUKTINFORMATION",
    bDrive: "Produktbilder",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Villkor för deltagande",
    first_stop: "Bridgestone däckgaranti",
    payouts: "Payouts",
},
  breadcrumbs: {
    dashboard: "Hem",
    accountDashboard: "Hem",
    account: "Min profil",
    mailbox: "Inkorg",
    singleMailbox: "Meddelanden",
    stammdaten: "Masterdata",
    news_feeds: "Nyheter",
    pointsOverview: "Poängöversikt",
    rewardsOverview: "Poängöversikt",
    about: "Om BS Plus",
    service_number: "Kontakta service",
    shop: "Belöningsbutik",
    salesPromotions: "Säljkampanjer",
    promotions: "Mitt konto",
    shopCategory: "Belöningsbutik",
    productDetails: "Produktdetaljer",
    userOrders: "Användarbeställningar",
    shoppingCart: "Varukorg",
    orderDelivery: "Leveransadress",
    orderSummary: "Orderöversikt",
    orderComplete: "Beställning slutförd",
    staff: "Servicepanel",
    trainings: "Utbildningar",
    training: "Utbildning",
    staffVouchers: "Kuponger",
    wholesalerVouchers: "Kuponger",
    brochure_prices: "Prislistor och broschyrer",
    investment: "Investeringsstod",
    media: "Media",
    medias: "Media",
    contact_service: "Kontakt och service",
    productInfo: "PRODUKTINFORMATION",
    bDrive: "Produktbilder",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Villkor för deltagande",
    first_stop: "Bridgestone däckgaranti",
    payouts: "Payouts",
},
  menu: {
    account: "Min profil",
    plus: 'Om Bridgestone <span class="text-danger">Plus</span>',
    salesSupport: "Soutien à la vente",
    mailbox: "Inkorg",
    about: "Om BS Plus",
    trainingAndCourses: "Formations et cours",
    externalTraining: "Formations externes",
    productInfo: "Informations sur les produits",
    productBrochures: "Brochures sur les produits",
    priceLists: "Prislistor",
    price: "Pricat",
    complaintForm: "Formulaire de réclamation",
    sales_support: "Soutien à la vente",
    contact_service: "Kontakt och service",
    logOut: "Logga ut",
    news: "Nyheter",
    news_feeds: "Nyheter",
    service_number: "Kontakta service",
    salesPromotions: "Säljkampanjer",
    shop: "Butik",
    onlineTrainings: "Onlineutbildningar",
    trainings: "Utbildningar",
    brochure_prices: "Prislistor och broschyrer",
    media: "Media",
    medias: "Media",
    stammdaten: "Masterdata",
    preislisten: "Prislistor",
  },
  validation: {
    requiredField: "Campo obligatorio",
  },
  sortBy: {
    default: "Sortera efter",
    desc: "Sortera efter: Nyaste",
    asc: "Sortera efter: Äldsta",
    name: "Namn",
    date: "Datum",
    choiceBy: "Sortera",
  },
  month: {
    1: "januari",
    2: "februari",
    3: "mars",
    4: "april",
    5: "maj",
    6: "juni",
    7: "juli",
    8: "augusti",
    9: "september",
    10: "oktober",
    11: "november",
    12: "december"
  },
};


export default {
  messages,
};
